var _rect, _rect2, _path, _path2, _tspan, _tspan2, _tspan3, _tspan4, _g, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgAnimatedBottomBar = function SvgAnimatedBottomBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.36,
    height: 78.35,
    className: "animated-bottom-bar_svg__animated-bottom-bar_svg__d-inline-block animated-bottom-bar_svg__animated-bottom-bar_svg__align-top",
    viewBox: "0 0 194.83 79.35"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194.83,
    height: 30.19,
    fill: "#fff",
    paintOrder: "fill markers stroke",
    rx: 3.54,
    ry: 3.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 194.83,
    height: 30.19,
    y: 49.16,
    fill: "#212125",
    paintOrder: "fill markers stroke",
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6302ee",
    d: "M56.25 0c0 1.08.87 1.94 1.95 1.94h29.79c1.07 0 1.94-.86 1.94-1.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M67.53 9.62h11.22v11.21H67.53z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.07,
    fontFamily: "'Google Sans'",
    fontSize: 6.62,
    fontWeight: "bold",
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("text", {
    x: 105.98,
    y: 16.8,
    style: {
      lineHeight: 1.25
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105.98,
    y: 16.8,
    fontWeight: "normal"
  }, "Stopwatch"))), /*#__PURE__*/React.createElement("text", {
    x: 161.99,
    y: 17.44,
    style: {
      lineHeight: 1.25
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 161.99,
    y: 17.44,
    fontWeight: "normal"
  }, "Timer"))), /*#__PURE__*/React.createElement("text", {
    x: 15.71,
    y: 17.41,
    style: {
      lineHeight: 1.25
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 15.71,
    y: 17.41,
    fontWeight: "normal"
  }, "Alarm"))), /*#__PURE__*/React.createElement("text", {
    x: 60.3,
    y: 66.6,
    fill: "#9aa4ff",
    style: {
      lineHeight: 1.25
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.3,
    y: 66.6,
    fontWeight: "normal"
  }, "Bedtime")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.53 9.62h11.22v11.21H67.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.82 12.29l-2.15-1.8-.6.71 2.15 1.8zm-6.6-1.09l-.6-.71-2.15 1.8.6.71zm2.16 2.16h-.7v2.8l2.22 1.33.35-.57-1.87-1.11zm-.24-1.87a4.2 4.2 0 100 8.41 4.2 4.2 0 000-8.41zm0 7.47a3.27 3.27 0 110-6.53 3.27 3.27 0 010 6.53z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9aa4ff",
    d: "M56.25 49.16c0 1.08.87 1.95 1.95 1.95h29.79c1.07 0 1.94-.87 1.94-1.95z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.85,
    d: "M166.04 59.35v2.95l1.96 1.96-1.96 1.96v2.94h5.88v-2.94l-1.96-1.96 1.96-1.97v-2.94h-5.88zm-45.67 0v.94h2.8v-.93h-2.8zm-98.54.2l-2.15 1.8.6.71 2.15-1.8-.6-.71zm5.05 0l-.6.71 2.15 1.8.6-.7-2.15-1.81zm140.14.78h3.92v1.72l-1.96 1.96-1.96-1.96v-1.72zm-142.66.22a4.2 4.2 0 000 8.41 4.2 4.2 0 000-8.41zm97.41.2a4.2 4.2 0 103.28 1.59l.67-.67c-.2-.23-.43-.45-.66-.65l-.66.67a4.14 4.14 0 00-2.63-.94zm46.23.56v.37l.98.98.98-.98v-.37H168zm-143.64.17a3.27 3.27 0 110 6.54 3.27 3.27 0 010-6.54zm97.41.2a3.27 3.27 0 110 6.55 3.27 3.27 0 010-6.54zm-97.88.74v2.8l2.22 1.33.35-.57-1.87-1.1v-2.46h-.7zm97.41.2v2.8h.94v-2.8h-.94zm47.68 1.88l1.96 1.96v1.72h-3.92v-1.72l1.96-1.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6302ee",
    d: "M70.92 15.86a1.33 1.33 0 100-2.67 1.33 1.33 0 000 2.67m0-1.78a.446.446 0 010 .89c-.57-.03-.57-.86 0-.89m5.34-1.34H72.7v3.57h-3.57v-4.46h-.89v6.69h.9V17.2h8.01v1.34h.9v-4.01c0-1-.8-1.79-1.79-1.79m.9 3.57h-3.57v-2.68h2.67c.5 0 .9.4.9.9z"
  })));
};

;
export default SvgAnimatedBottomBar;